// Reservations Reducer

import { API_STATUS } from '../../../utilities/constants';
import { initializeState } from '../../../utilities/storageUtils';
import reservationsActionTypes from './reservations.types';

const INITIAL_STATE = {
  reservationList: [],
  upcomingReservationList: [],
  pastReservationList: [],
  canceledReservationList: [],
  getReservationsApiStatus: API_STATUS.IDLE,
  createReservationApiStatus: API_STATUS.IDLE,
  initialLoadApiStatus: API_STATUS.IDLE,
  errorMessage: null,
  errorType: '',
  status: '',
  lastNameFindReservationById: ''
};

/**
 *
 * IMPORTANT!!!
 * The validation of reservation.isCabana is required to avoid showing cabanas reservations
 * this was implemented by story 30448, this is just a FE fix, the fix needs to be completed
 * on the BE and will be implemented on another story
 */
export function reservationListHandler(reservationData) {
  const reservedReservations = reservationData['RESERVED'] ? reservationData['RESERVED'] : [];
  const changedReservations = reservationData['CHANGED'] ? reservationData['CHANGED'] : [];
  const noShowReservations = reservationData['NO_SHOW'] ? reservationData['NO_SHOW'] : [];
  const checkedOutReservations = reservationData['CHECKEDOUT'] ? reservationData['CHECKEDOUT'] : [];
  const filteredReservations = {
    upcomingReservationList: [...reservedReservations, ...changedReservations] ?? [],
    pastReservationList: [...noShowReservations, ...checkedOutReservations] ?? [],
    canceledReservationList: reservationData['CANCELED'] ?? []
  };
  return filteredReservations;
}

const reservationsReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  // Get Book information reducers
  switch (action.type) {
    case reservationsActionTypes.SET_RESERVATION_LAST_NAME_FIND_BY_ID:
      return {
        ...state,
        lastNameFindReservationById: action.lastName
      };

    case reservationsActionTypes.CREATE_RESERVATION_LOADING:
      return {
        ...state,
        createReservationApiStatus: API_STATUS.LOADING
      };

    case reservationsActionTypes.CREATE_RESERVATION_COMPLETE:
      return {
        ...state,
        createReservationApiStatus: API_STATUS.SUCCEEDED
      };
    case reservationsActionTypes.CREATE_RESERVATION_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
        errorType: action.errorType
      };

    // Reservation item request succeded
    case reservationsActionTypes.GET_RESERVATION_INFO_SUCCESS:
      return {
        ...state,
        reservationList: action.reservationList,
        upcomingReservationList: action.upcomingReservationList,
        pastReservationList: action.pastReservationList,
        canceledReservationList: action.canceledReservationList,
        getReservationsApiStatus: API_STATUS.SUCCEEDED,
        initialLoadApiStatus: API_STATUS.SUCCEEDED,
        errorMessage: null
      };
    // The request is currently running
    case reservationsActionTypes.GET_RESERVATION_INFO_LOADING:
      return {
        ...state,
        getReservationsApiStatus: API_STATUS.LOADING,
        ...(action.auxFlagSetIsInitialLoad && { initialLoadApiStatus: API_STATUS.LOADING })
      };
    // Reservation item request failed
    case reservationsActionTypes.GET_RESERVATION_INFO_ERROR:
      return {
        ...state,
        reservationList: [],
        upcomingReservationList: [],
        pastReservationList: [],
        canceledReservationList: [],
        getReservationsApiStatus: API_STATUS.ERROR,
        initialLoadApiStatus: API_STATUS.ERROR,
        errorMessage: action.errorMessage
      };
    // Action to clear the errors
    case reservationsActionTypes.CLEAR_RESERVATION_ERROR:
      return {
        ...state,
        getReservationsApiStatus: API_STATUS.IDLE,
        errorMessage: null,
        errorType: ''
      };

    default:
      return state;
  }
};

export default reservationsReducer;
